/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Progress_CompletedInputs */

const en_new_project_media_progress_completed = /** @type {(inputs: New_Project_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const fr_new_project_media_progress_completed = /** @type {(inputs: New_Project_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine`)
};

const de_new_project_media_progress_completed = /** @type {(inputs: New_Project_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollendet`)
};

const it_new_project_media_progress_completed = /** @type {(inputs: New_Project_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completato`)
};

const ru_new_project_media_progress_completed = /** @type {(inputs: New_Project_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершенный`)
};

const es_new_project_media_progress_completed = /** @type {(inputs: New_Project_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminado`)
};

const zh_cn2_new_project_media_progress_completed = /** @type {(inputs: New_Project_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全的`)
};

const ja_new_project_media_progress_completed = /** @type {(inputs: New_Project_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

const hi_new_project_media_progress_completed = /** @type {(inputs: New_Project_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुरा होना।`)
};

const pt_pt2_new_project_media_progress_completed = /** @type {(inputs: New_Project_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluído`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {New_Project_Media_Progress_CompletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_progress_completed = /** @type {((inputs?: New_Project_Media_Progress_CompletedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Progress_CompletedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_media_progress_completed(inputs)
	if (locale === "de") return de_new_project_media_progress_completed(inputs)
	if (locale === "it") return it_new_project_media_progress_completed(inputs)
	if (locale === "ru") return ru_new_project_media_progress_completed(inputs)
	if (locale === "es") return es_new_project_media_progress_completed(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_media_progress_completed(inputs)
	if (locale === "ja") return ja_new_project_media_progress_completed(inputs)
	if (locale === "hi") return hi_new_project_media_progress_completed(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_media_progress_completed(inputs)
	return en_new_project_media_progress_completed(inputs)
});